<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <!-- <el-form-item label="ASIN:" class="query-form-item">
                <el-input v-model="query.asin" placeholder="请输入ASIN" clearable style="width: 150px;"></el-input>
            </el-form-item> -->
            <el-form-item label="项目组:" class="query-form-item">
                <el-input
                    v-model="query.project_name"
                    placeholder="项目组"
                    clearable
                    style="width: 150px;"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
                <el-button type="success" @click="onupload"
                    >上传SB广告数据文件</el-button
                >
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :height="tableHeight"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
            @sort-change="handleSortChange"
            style="width: 100%;"
        >
            <el-table-column label="ID" width="80" align="center" fixed>
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="项目组" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.project_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="国家" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.state == 'US'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>美国</span>
                    </div>
                    <div v-if="scope.row.state == 'de'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>德国</span>
                    </div>
                    <div v-if="scope.row.state == 'uk'">
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-right:5px;"
                        ></icon-svg>
                        <span>英国</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="上传的文件名"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.filename }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="上传时间"
                sortable="custom"
                prop="add_time"
                width="144"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time.replace(/T/g, " ") }}</div>
                </template>
            </el-table-column>
            <!--<el-table-column-->
                <!--label="广告基础信息"-->
                <!--sortable="custom"-->
                <!--prop="add_time"-->
                <!--width="150"-->
                <!--align="center"-->
            <!--&gt;-->
                <!--<template slot-scope="scope">-->
                    <!--<el-button-->
                        <!--style="margin: 5px 0 5px 10px"-->
                        <!--type="success"-->
                        <!--size="mini"-->
                        <!--@click="openAdData(scope.row)"-->
                        <!--&gt;查看</el-button-->
                    <!--&gt;-->
                <!--</template>-->
                <!-- <template slot-scope="scope">
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="openAdData(scope.row)"
                        >添加sku</el-button
                    >
                </template> -->
            <!--</el-table-column>-->
            <el-table-column
                label="日耗值"
                sortable="custom"
                prop="add_time"
                width="144"
                align="center"
            >
                <template slot-scope="scope">
                    <div>
                        <span style="margin-right:10px">{{
                            scope.row.daily_budget || "-"
                        }}</span>
                        <i
                            class="el-icon-edit"
                            @click="edit_daily_budget(scope.row)"
                        ></i>
                    </div>
                </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                label="阿波罗转移+内部竞价优化"-->
<!--                sortable="custom"-->
<!--                width="250"-->
<!--                align="center"-->
<!--            >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button-->
<!--                        v-if="scope.row.apollo === 2"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        @click="downFile(scope.row.apollo_path)"-->
<!--                        >下载解析文件</el-button-->
<!--                    >-->
<!--                    &lt;!&ndash;<el-button&ndash;&gt;-->
<!--                        &lt;!&ndash;v-if="scope.row.apollo === -1"&ndash;&gt;-->
<!--                        &lt;!&ndash;style="margin: 5px 0 5px 10px"&ndash;&gt;-->
<!--                        &lt;!&ndash;type="danger"&ndash;&gt;-->
<!--                        &lt;!&ndash;size="mini"&ndash;&gt;-->
<!--                        &lt;!&ndash;@click="copyMsg(scope.row.apollo_err_msg)"&ndash;&gt;-->
<!--                        &lt;!&ndash;&gt;{{ scope.row.apollo_err_msg }}</el-button&ndash;&gt;-->
<!--                    &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                    <div v-if="scope.row.apollo === -1">-->
<!--                        &lt;!&ndash;<el-tooltip&ndash;&gt;-->
<!--                            &lt;!&ndash;class="item"&ndash;&gt;-->
<!--                            &lt;!&ndash;effect="dark"&ndash;&gt;-->
<!--                            &lt;!&ndash;:content="scope.row.apollo_err_msg"&ndash;&gt;-->
<!--                            &lt;!&ndash;placement="top-start"&ndash;&gt;-->
<!--                        &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                            &lt;!&ndash;<el-button size="mini">查看完整错误信息</el-button>&ndash;&gt;-->
<!--                        &lt;!&ndash;</el-tooltip>&ndash;&gt;-->
<!--                        <el-button-->
<!--                            type="danger"-->
<!--                            size="mini"-->
<!--                            @click="showErrorInfo(scope.row)"-->
<!--                        >查看完整错误信息</el-button>-->
<!--                    </div>-->
<!--                    <el-button-->
<!--                        v-if="scope.row.apollo === 0"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        @click="startApolloDecode(scope.row)"-->
<!--                        >开始解析</el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="scope.row.apollo === 1"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        >{{scope.row.apollo_str}}</el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="scope.row.apollo !== 0 && scope.row.apollo !== 1"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        @click="startApolloDecode(scope.row, 1)"-->
<!--                        >重新解析</el-button-->
<!--                    >-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                label="前置否定"
                sortable="custom"
                prop="add_time"
                width="260"
                align="center"
            >
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.predisavowal === 2"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downFile(scope.row.predisavowal_path)"
                    >下载解析文件</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        @click="showErrorInfo(scope.row.predisavowal_err_msg)"
                        v-if="scope.row.predisavowal === -1"
                    >查看错误信息</el-button>
<!--                    <el-button-->
<!--                        v-if="scope.row.predisavowal === -1"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="danger"-->
<!--                        size="mini"-->
<!--                        @click="parsing_predisavowal_file(scope.row, 1)"-->
<!--                    >{{ scope.row.predisavowal_err_msg }}</el-button-->
<!--                    >-->
                    <el-button
                        v-if="scope.row.predisavowal === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="parsing_predisavowal_file(scope.row)"
                    >开始解析</el-button
                    >
                    <el-button
                        v-if="scope.row.predisavowal === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                    >{{ scope.row.predisavowal_str || "解析中" }}</el-button
                    >

					<el-button
					    v-if="scope.row.predisavowal !== 0 && scope.row.predisavowal !== 1"
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    @click="parsing_predisavowal_file(scope.row, 1)"
					    >重新解析</el-button
					>
                </template>
            </el-table-column>
            <el-table-column
                label="降Bid优化"
                sortable="custom"
                prop="add_time"
                width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="openBidList(scope.row)"
                        >列表</el-button
                    >
                </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                label="运营分析"-->
<!--                sortable="custom"-->
<!--                prop="add_time"-->
<!--                width="250"-->
<!--                align="center"-->
<!--            >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button-->
<!--                        v-if="scope.row.operating === 2"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        @click="downFile(scope.row.operating_path)"-->
<!--                        >下载解析文件</el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="scope.row.operating === -1"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="danger"-->
<!--                        size="mini"-->
<!--                        @click="parsing_ad_expenses_file(scope.row, 1)"-->
<!--                        >{{ scope.row.operating_err_msg }}</el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="scope.row.operating === 0"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        @click="parsing_ad_expenses_file(scope.row)"-->
<!--                        >开始解析</el-button-->
<!--                    >-->
<!--                    <el-button-->
<!--                        v-if="scope.row.operating === 1"-->
<!--                        style="margin: 5px 0 5px 10px"-->
<!--                        type="success"-->
<!--                        size="mini"-->
<!--                        >{{ scope.row.operating_str || "解析中" }}</el-button-->
<!--                    >-->
<!--					<el-button-->
<!--					    v-if="scope.row.operating !== 0 && scope.row.operating !== 1"-->
<!--					    style="margin: 5px 0 5px 10px"-->
<!--					    type="success"-->
<!--					    size="mini"-->
<!--					    @click="parsing_ad_expenses_file(scope.row, 1)"-->
<!--					    >重新解析</el-button-->
<!--					>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                label="内部竞价优化"
                sortable="custom"
                prop="add_time"
                width="260"
                align="center"
            >
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.optimization === 2"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downFile(scope.row.optimization_path)"
                        >下载解析文件</el-button
                    >
                    <el-button
                        type="danger"
                        size="mini"
                        @click="showErrorInfo(scope.row.optimization_err_msg)"
                        v-if="scope.row.optimization === -1"
                    >查看错误信息</el-button>
                    <el-button
                        v-if="scope.row.optimization === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row)"
                        >开始解析</el-button
                    >
                    <el-button
                        v-if="scope.row.optimization === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        >{{ scope.row.optimization_str || "解析中" }}</el-button
                    >
					<el-button
					    v-if="scope.row.optimization !== 0 && scope.row.optimization !== 1"
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    @click="startDecode(scope.row, 1)"
					    >重新解析</el-button
					>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260" fixed="right">
                <template slot-scope="scope">
                    <!-- <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="brandBidding(scope.row)" :disabled="listDisabled">品牌竞价</el-button> -->
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downFile(scope.row.source_path)"
                        >下载源文件</el-button
                    >
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_file(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; padding-bottom: 30px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :us_arr="us_arr"
            :title="'上传SB广告数据文件'"
            @close-callback="closeCllback"
        ></upload>
        <DownloadList
            :activeName="activeName"
            :visible="ctrl.DownloadListDialogVisible"
            :title="'下载列表'"
            @close-callback="closeCllback"
        >
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    label="防内部竞价"
                    name="antiInternal"
                    style="padding: 0 25px;"
                >
                    <DownloadView
                        ref="antiInternal"
                        :task_type="1"
                    ></DownloadView>
                </el-tab-pane>
                <el-tab-pane
                    label="品牌竞价"
                    name="brand"
                    style="padding: 0 25px;"
                >
                    <DownloadView ref="brand" :task_type="2"></DownloadView>
                </el-tab-pane>
            </el-tabs>
        </DownloadList>
        <AddPpc
            :visible="ctrl.addPpcDialogVisible"
            :record_id="record_id"
            :title="'添加广告优化记录'"
            @close-callback="closeCllback"
        ></AddPpc>
        <BidList
            title="列表记录"
            :id="currentId"
            v-if="ctrl.bidDialogVisible"
            :visible="ctrl.bidDialogVisible"
            @close-callback="closeCllback"
        />
        <AddBaseAdData
            title="广告组基础信息"
            :data="adData"
            v-if="adDataShow"
            :visible="adDataShow"
            @close-callback="closeAdBaseData"
        />
        <el-dialog
            style="padding: 0 20px 20px 20px !important;"
            width="50%"
            title="修改日耗值"
            v-if="dailyShow"
            :visible.sync="dailyShow"
        >
            <elForm>
                <el-form-item
                    label="日耗值:"
                    class="query-form-item"
                    v-if="dailyShow"
                >
                    <el-input
                        v-model="dailyData.daily_budget"
                        placeholder="请输入日耗值"
                        type="number"
                        clearable
                        style="width: 150px;"
                    ></el-input>
                </el-form-item>
            </elForm>
            <el-row style="margin-top:17px; ">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleDailyClose()"
                    >取 消</el-button
                >
                <el-button
                    style="float:right"
                    size="mini"
                    type="primary"
                    @click="submitDeily()"
                    >确定</el-button
                >
            </el-row>
        </el-dialog>
        <el-dialog
            style="padding: 0 20px 20px 20px !important;"
            width="30%"
            center
            title="错误信息"
            v-if="errorInfoShow"
            :visible.sync="errorInfoShow"
        >
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
                <!--<el-button @click="errorInfoShow = false">取 消</el-button>-->
                <el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as api from "@/api/statistics/statistics";
import * as apis from '@/api/Product/Product.js'
import Upload from "./newupload";
import DownloadList from "../downloadList";
import DownloadView from "../downloadView";
import AddBaseAdData from "./addBaseAdData";
import BidList from "../bidList.vue";
import AddPpc from "../addPpc";
import { downloadFileUrl } from "@/utils/method";

let timer = null,
    adTimer = null,
    prTimer = null,
    apTimer = null;
export default {
    components: {
        Upload,
        DownloadList,
        DownloadView,
        AddPpc,
        BidList,
        AddBaseAdData
    },
    data() {
        return {
            dailyShow: false,
            errorMsg: '',
            errorInfoShow: false,
            dailyData: {},
            currentId: "",
            tableHeight: null,
            ctrl: {
                DownloadListDialogVisible: false,
                addPpcDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false
            },
            typeArr: [
                {
                    index: 1,
                    title: "广告层面"
                },
                {
                    index: 2,
                    title: "逻辑层面"
                }
            ],
            us_arr: [
                {
                    us: "us",
                    title: "美国"
                },
                {
                    us: "uk",
                    title: "英国"
                },
                {
                    us: "de",
                    title: "德国"
                }
            ],
            query: {
                page: 1,
                limit: 20,
                total: 0,
                project_name: "",
                state: "",
                order: "",
                desc: ""
            },
            record_id: 0,
            activeName: "antiInternal",
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            adParseStatusList: [],
            apolloStatusList: [],
            predisavowalStatusList: [],
            adDataShow: false,
            adData: {}
        };
    },
    created() {
        this.query.asin = this.$route.query.asin;
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
        this.getList();
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    destroyed() {
        clearInterval(timer);
    },
    methods: {
        showErrorInfo(info){
            this.errorInfoShow = true;
            this.errorMsg = info || '';
        },
        copyMsg(msg) {
            console.log(msg);
            var input = document.createElement("input"); // js创建一个input输入框
            input.value = msg; // 将需要复制的文本赋值到创建的input输入框中
            document.body.appendChild(input); // 将输入框暂时创建到实例里面
            input.select(); // 选中输入框中的内容
            document.execCommand("Copy"); // 执行复制操作
            document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
        },
        getList() {
            this.loading = true;
            api.sb_ad_data_index({
                ...this.query,
                asin_id: this.$route.query.ad_portfolio_name_id,
                state: this.$route.query.state,
                asin: this.$route.query.asin
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.list.forEach(item => {
                            if (item.optimization === 1) {
                                this.parseStatusList.push(item.id);
                                item.operating === 1 &&
                                    this.get_ad_parse_status();
                                item.optimization === 1 &&
                                    this.get_parse_status();
                            }
                            if (item.operating === 1) {
                                this.adParseStatusList.push(item.id);
                                this.get_ad_parse_status();
                            }``
                             if (item.apollo === 1) {
                                 this.apolloStatusList.push(item.id);
                                 this.get_apollo_parse_status();
                             }
                            if (item.predisavowal === 1) {
                                this.predisavowalStatusList.push(item.id);
                                this.get_predisavowal_parse_status();
                            }
                        });

                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        antiInternalBidding() {
            this.disabled = true;
            api.listing_prevent_internal_competition({
                asin: this.query.asin
            })
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        brandBidding(data) {
            this.listDisabled = true;
            api.check_brand_ppc({
                asin: this.query.asin,
                record_id: data.id
            })
                .then(res => {
                    this.listDisabled = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message:
                                "正在分析数据，后续可通过下载列表进行下载文件！"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.listDisabled = false;
                });
        },
        handleSortChange(val) {
            if (val.order == "ascending") {
                this.query.desc = "desc";
                this.query.order = val.prop;
            } else if (val.order == "descending") {
                this.query.desc = "asc";
                this.query.order = val.prop;
            }
            this.getList();
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList();
            });
        },
        //重置
        onReset() {
            this.query.project_name = "";
            this.query.state = "";
            this.query.order = "";
            this.query.desc = "";
            this.query.page = 1;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        change() {
            this.getList();
        },
        clearValue() {
            this.query.state = "";
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true;
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true;
            this.$nextTick(() => {
                this.$refs[this.activeName].getList();
            });
        },
        // bid记录列表
        openBidList(data) {
            console.log("data", data);
            this.currentId = data.id;
            this.ctrl.bidDialogVisible = true;
        },
        async startApolloDecode(row, force = 0) {
            if (force) {
                await this.$confirm("是否重新解析任务", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
            }
            let list = JSON.parse(JSON.stringify(this.list));
            api.parsing_apollo_file({
                id: row.id,
                force
            }).then(res => {
                if (res.code === -1) {
                    return this.$message({
                        type: "error",
                        message: res.message
                    });
                }
                const index = list.findIndex(item => item.id === row.id);
                list[index].apollo = 1;
				list[index].apollo_str = '解析中';
                this.list = list;
                this.apolloStatusList.push(row.id);
                 !apTimer && this.get_apollo_parse_status();
            });
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm("是否重新运行解析任务", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
            }
            console.log("cc");
            let list = JSON.parse(JSON.stringify(this.list));
            apis.sb_bid_optimization_parsing_file({
                id: row.id,
                force
            }).then(res => {
                if (res.code === -1) {
                    return this.$message({
                        type: "error",
                        message: res.message
                    });
                }
                const index = list.findIndex(item => item.id === row.id);
                list[index].optimization = 1;
				list[index].optimization_str = '解析中';
                this.list = list;
                this.parseStatusList.push(row.id);
                !timer && this.get_parse_status();
            });
        },
        async parsing_predisavowal_file(row, force = 0) {
            if (force) {
                await this.$confirm("是否重新运行解析任务", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
            }
            console.log("cc");
            let list = JSON.parse(JSON.stringify(this.list));
            apis.sb_predisavowal_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id);
                list[index].predisavowal = 1;
				list[index].predisavowal_str = '解析中';
                this.list = list;
                this.predisavowalStatusList.push(row.id);
                !prTimer && this.get_predisavowal_parse_status();
            });
        },
        async parsing_ad_expenses_file(row, force = 0) {
            if (force) {
                await this.$confirm("是否重新运行解析任务", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                });
            }
            console.log("cc");
            let list = JSON.parse(JSON.stringify(this.list));
            api.parsing_ad_expenses_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id);
                list[index].operating = 1;
				list[index].operating_str = '解析中';
                this.list = list;
                this.adParseStatusList.push(row.id);
                !adTimer && this.get_ad_parse_status();
            });
        },
        get_ad_parse_status() {
            // adTimer = setInterval(() => {
            //     api.get_parse_status({
            //         ids: this.adParseStatusList
            //     }).then(res => {
            //         let shouldClear = true;
            //         let list = JSON.parse(JSON.stringify(this.list));
            //         list.forEach((item, index) => {
            //             res.data.forEach(i => {
            //                 if (item.id === i.id) {
            //                     list[index] = Object.assign(
            //                         {},
            //                         this.list[index],
            //                         i
            //                     );
            //                     if (i.operating === 1) {
            //                         shouldClear = false;
            //                     }
            //                 }
            //             });
            //         });
            //         if (shouldClear) {
            //             this.adParseStatusList = [];
            //             clearInterval(adTimer);
            //             adTimer = null;
            //         }
            //         this.list = list;
            //     });
            // }, 5000);
        },
        get_parse_status() {
            // timer = setInterval(() => {
            //     api.get_parse_status({
            //         ids: this.parseStatusList
            //     }).then(res => {
            //         let shouldClear = true;
            //         let list = JSON.parse(JSON.stringify(this.list));
            //         list.forEach((item, index) => {
            //             res.data.forEach(i => {
            //                 if (item.id === i.id) {
            //                     list[index] = Object.assign(
            //                         {},
            //                         this.list[index],
            //                         i
            //                     );
            //                     if (i.optimization === 1) {
            //                         shouldClear = false;
            //                     }
            //                 }
            //             });
            //         });
            //         if (shouldClear) {
            //             clearInterval(timer);
            //             this.parseStatusList = [];
            //             timer = null;
            //         }
            //         this.list = list;
            //     });
            // }, 5000);
        },
        get_apollo_parse_status() {
            // let _this = this;
            // function run() {
            //     api.get_parse_status({
            //         ids: _this.apolloStatusList
            //     }).then(res => {
            //         let shouldClear = true;
            //         let list = JSON.parse(JSON.stringify(_this.list));
            //         list.forEach((item, index) => {
            //             res.data.forEach(i => {
            //                 if (item.id === i.id) {
            //                     list[index] = Object.assign(
            //                         {},
            //                         _this.list[index],
            //                         i
            //                     );
            //                     if (i.apollo === 1) {
            //                         shouldClear = false;
            //                     }
            //                 }
            //             });
            //         });
            //         if (shouldClear) {
            //             clearInterval(apTimer);
            //             _this.apolloStatusList = [];
            //             apTimer = null;
            //         }
            //         _this.list = list;
            //     });
            // }
            // run();
            // apTimer = setInterval(() => {
            //     run();
            // }, 5000);
        },
        get_predisavowal_parse_status() {
            // let _this = this;
            // function run() {
            //     api.get_parse_status({
            //         ids: _this.predisavowalStatusList
            //     }).then(res => {
            //         let shouldClear = true;
            //         let list = JSON.parse(JSON.stringify(_this.list));
            //         list.forEach((item, index) => {
            //             res.data.forEach(i => {
            //                 if (item.id === i.id) {
            //                     list[index] = Object.assign(
            //                         {},
            //                         _this.list[index],
            //                         i
            //                     );
            //                     if (i.predisavowal === 1) {
            //                         shouldClear = false;
            //                     }
            //                 }
            //             });
            //         });
            //         if (shouldClear) {
            //             clearInterval(prTimer);
            //             _this.predisavowalStatusList = [];
            //             prTimer = null;
            //         }
            //         _this.list = list;
            //     });
            // }
            // run();
            // prTimer = setInterval(() => {
            //     run();
            // }, 5000);
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            downloadFileUrl(path);
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id;
            this.ctrl.addPpcDialogVisible = true;
        },
        //删除
        delete_file(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.sb_ad_data_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getList();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.uploadDialogVisible = false;
            this.ctrl.addPpcDialogVisible = false;
            this.ctrl.DownloadListDialogVisible = false;
            this.ctrl.bidDialogVisible = false;
            this.currentId = "";
            isshow == true && this.getList();
        },
        openAdData(data) {
            this.adDataShow = true;
            this.adData = JSON.parse(JSON.stringify(data));
        },
        closeAdBaseData(isshow) {
            this.adDataShow = false;
            isshow == true && this.getList();
        },
        edit_daily_budget(data) {
            this.dailyShow = true;
            this.dailyData = JSON.parse(JSON.stringify(data));
        },
        submitDeily() {
            let force = 0;
            force = 1;
            api.sb_ad_data_update_daily_budget({
                id: this.dailyData.id,
                daily_budget: Number(this.dailyData.daily_budget),
                force
            }).then(() => {
                this.getList();
                this.handleDailyClose();
                this.$message({
                    type: "success",
                    message: "修改成功"
                });
            });
            // this.$confirm("是否重新解析阿波罗文件", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning"
            // })
            //     .then(() => {
            //         force = 1;
            //     })
            //     .finally(() => {
            //         api.sb_ad_data_update_daily_budget({
            //             id: this.dailyData.id,
            //             daily_budget: Number(this.dailyData.daily_budget),
            //             force
            //         }).then(() => {
            //             this.getList();
            //             this.handleDailyClose();
            //             this.$message({
            //                 type: "success",
            //                 message: "修改成功"
            //             });
            //         });
            //     });
        },
        handleDailyClose() {
            this.dailyShow = false;
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
